import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import type { PropsWithChildren } from 'react';

export function TwoColumnLayout({ children }: PropsWithChildren) {
  return <div className="grid grid-cols-2 gap-2 overflow-hidden whitespace-nowrap">{children}</div>;
}

function Column({ children, indent }: PropsWithChildren<{ indent?: boolean }>) {
  return (
    <div className={cn('flex flex-col gap-2 overflow-hidden', indent && 'ms-6')}>{children}</div>
  );
}

TwoColumnLayout.Column = Column;
